import { normalizeSuggestionKeywords } from "@/components/suggestions/providers/utils/normalizeKeywords";
import { canSetColor } from "@/models/nodes/utils";

import type { ColorSuggestion, SuggestionProvider } from "@/components/suggestions/types";

export const colorSuggestionsProvider: SuggestionProvider<"color"> = {
  type: "color",
  search: (_str, doc) => {
    const { tiptap, editorState } = doc.editor;
    if (!tiptap) {
      return [];
    }

    const { selectedNodes } = doc.selection;
    const [selectedNode] = selectedNodes;

    if (selectedNodes.length === 1 && canSetColor(selectedNode)) {
      const suggestion: ColorSuggestion = {
        type: "color",
        target: "node",
        trackingId: "color",
        color: selectedNode.color,
        nodeId: selectedNode.id,
        keywords: normalizeSuggestionKeywords({ keywords: ["colour", "palette"] }),
        priority: 0,
        popupGroup: "color",
      };

      return [[suggestion]];
    }

    if (doc.cursor.isActive) {
      return [];
    }

    const { selection } = tiptap.state;
    if (selection.empty || editorState.isExpression || !editorState.isText) {
      return [];
    }

    const suggestion: ColorSuggestion = {
      type: "color",
      target: "text",
      trackingId: "color",
      color: editorState.textColor ?? "black",
      keywords: normalizeSuggestionKeywords({ keywords: ["colour", "palette"] }),
      priority: 0,
      popupGroup: "color",
    };

    return [[suggestion]];
  },
};
